<template>
  <v-dialog :value="model.active" min-width="400" width="60vw" persistent>
    <v-card class="w-100">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left> mdi-file</v-icon>
          Inspect Report
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <div class="inspect-report__viewer">
        <DocumentViewerShell v-if="model.active && reportDocument" :document="reportDocument" />
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
  import DocumentViewerShell from '@/features/Documents/viewer/DocumentViewerShell.vue';

  export default {
    name: 'InspectReportPopup',
    components: { DocumentViewerShell },
    data() {
      return {
        model: {
          active: false,
          report: null,
        },
      };
    },
    computed: {
      /**
       * Reports are PDFs in the company's storage container. The viewer strips the stored SAS and
       * appends a fresh read SAS (a stored one expires), and sends no auth token: an Authorization
       * header on a SAS link makes Azure reject the request.
       */
      reportDocument() {
        const report = this.model.report;
        if (!report?.url) return null;
        return {
          fileName: report.fileName || report.name || 'Inspection report.pdf',
          contentType: 'application/pdf',
          url: report.url,
        };
      },
    },
    methods: {
      closeDialog() {
        this.model.active = false;
      },
      openDialog(report) {
        this.model.report = report;
        this.model.active = true;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .inspect-report__viewer {
    height: 80vh;
    display: flex;
  }
</style>
